import { Box, Typography } from '@mui/material';
import { ReceiptLongOutlined } from '@mui/icons-material';
import { getInvoices } from '../../../../helpers/api';
import FinancialReportPage, {
  StatusChip,
  formatDate,
  naira,
  reportPeriod,
} from './FinancialReportPage';

const INVOICE_STATUSES = [
  { value: '', label: 'All statuses' },
  { value: 'open', label: 'Open' },
  { value: 'ongoing', label: 'Ongoing' },
  { value: 'closed', label: 'Closed' },
];

const invoiceColumns = [
  {
    key: 'invoiceNo',
    label: 'Invoice',
    render: (r) => (
      <Box>
        <Typography variant="body2" fontWeight={600}>
          {r.invoiceNo || r.invoiceTitle || '–'}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Issued {formatDate(r.entryDate)}
        </Typography>
      </Box>
    ),
    csv: (r) => r.invoiceNo || r.invoiceTitle,
  },
  { key: 'facilityName', label: 'Facility', wrap: true, render: (r) => r.facilityName || '–' },
  {
    key: 'report',
    label: 'Report',
    render: (r) => reportPeriod(r) || '–',
    csv: reportPeriod,
  },
  {
    key: 'totalAmount',
    label: 'Total',
    align: 'right',
    render: (r) => naira(r.totalAmount ?? r.amount),
    csv: (r) => r.totalAmount ?? r.amount,
  },
  { key: 'totalAmountPaid', label: 'Paid', align: 'right', render: (r) => naira(r.totalAmountPaid) },
  {
    key: 'outstandingAmount',
    label: 'Outstanding',
    align: 'right',
    render: (r) => (
      <Typography
        variant="body2"
        fontWeight={600}
        color={Number(r.outstandingAmount) > 0 ? '#d32f2f' : 'text.primary'}
      >
        {naira(r.outstandingAmount)}
      </Typography>
    ),
  },
  {
    key: 'paymentDueDate',
    label: 'Due',
    render: (r) => formatDate(r.paymentDueDate),
    csv: (r) => formatDate(r.paymentDueDate),
  },
  {
    key: 'invoiceStatus',
    label: 'Status',
    render: (r) => <StatusChip status={r.invoiceStatus} />,
    csv: (r) => r.invoiceStatus,
  },
];

// The invoices endpoint has no year filter; year only affects the totals
const fetchInvoices = ({ facilityId, status, start, stop }) =>
  getInvoices('', facilityId, status, '', start, stop);

// Reporting > Financial > QA/QC Invoices
export default function InvoiceReport() {
  return (
    <FinancialReportPage
      title="QA/QC Invoices"
      description="Invoices raised for QA/QC monitoring, what has been paid and what is still outstanding."
      icon={<ReceiptLongOutlined />}
      listTitle="Invoices"
      noun="invoices"
      columns={invoiceColumns}
      rowKey={(r) => r.invoiceId}
      statusOptions={INVOICE_STATUSES}
      fetchRows={fetchInvoices}
      exportName="invoices"
      note="The year filter applies to the totals above; the invoice list is filtered by facility and status."
    />
  );
}
